import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { VehiclesEntityEffects } from './vehicles.effects';

@NgModule({
  imports: [CommonModule, EffectsModule.forFeature([VehiclesEntityEffects])]
})
export class VehiclesEntityModule {}
